var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#CEDCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0003 16.6665C22.6363 16.6665 16.667 22.6358 16.667 29.9998C16.667 37.3638 22.6363 43.3332 30.0003 43.3332C37.3643 43.3332 43.3337 37.3638 43.3337 29.9998C43.3337 22.6358 37.3643 16.6665 30.0003 16.6665ZM25.3337 26.6665C25.3337 26.0537 25.4544 25.4468 25.6889 24.8806C25.9234 24.3145 26.2672 23.8 26.7005 23.3667C27.1338 22.9333 27.6483 22.5896 28.2145 22.3551C28.7807 22.1205 29.3875 21.9998 30.0003 21.9998C30.6132 21.9998 31.22 22.1205 31.7862 22.3551C32.3524 22.5896 32.8668 22.9333 33.3002 23.3667C33.7335 23.8 34.0772 24.3145 34.3118 24.8806C34.5463 25.4468 34.667 26.0537 34.667 26.6665C34.667 27.9042 34.1753 29.0912 33.3002 29.9663C32.425 30.8415 31.238 31.3332 30.0003 31.3332C28.7626 31.3332 27.5757 30.8415 26.7005 29.9663C25.8253 29.0912 25.3337 27.9042 25.3337 26.6665ZM38.3443 36.6452C37.3462 37.9007 36.0774 38.9144 34.6326 39.6108C33.1877 40.3071 31.6042 40.668 30.0003 40.6665C28.3964 40.668 26.8129 40.3071 25.3681 39.6108C23.9233 38.9144 22.6544 37.9007 21.6563 36.6452C23.8177 35.0945 26.767 33.9998 30.0003 33.9998C33.2337 33.9998 36.183 35.0945 38.3443 36.6452Z",
    fill: "#4974D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIconUser);
export default __webpack_public_path__ + "static/media/img-icon-user.d820a6c2d77cdabd42a93abb905566b9.svg";
export { ForwardRef as ReactComponent };